'use client';

import styled from 'styled-components';

import { ScFormGroup } from '@/components/form/groups/styled';
import { device } from '@/styles/helpers';

export const ScAutoRegistration = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 480px;
  margin: 8px auto;
  padding: 32px;
  border-radius: 24px;
  color: ${({ theme }) => theme.blackColor};
  background: ${({ theme }) => theme.whiteColor};

  h2 {
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    text-transform: uppercase;
    margin-bottom: 32px;
    text-align: center;
  }

  form {
    .description,
    .user-email {
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      margin-bottom: 32px;
    }

    ${ScFormGroup} {
      margin-bottom: 32px;
    }

    .user-email {
      color: ${({ theme }) => theme.mainColor};
      font-weight: 700;
      letter-spacing: 0.16px;
    }
  }

  @media (${device.mobile}) {
    padding: 32px 16px;

    h2 {
      font-size: 24px;
      text-align: center;
      margin-bottom: 10px;
    }
  }
`;
